export default __webpack_public_path__ + "static/media/18.b0243f9c.jpg";